'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useMemo } from 'react';
import { type AccessRequirements, checkAccess as checkPureAccess } from '@repo/permissions/access';
import { useAuth } from './context';
import type { User } from './types';
export { normalizeName } from '@repo/permissions/access';
export interface AccessState {
  allowed: boolean;
  hasPermission: boolean;
  hasRole: boolean;
  isAuthenticated: boolean;
  isLoading: boolean;
  missingPermissions: string[];
  missingRoles: string[];
  user: null | User;
}
interface RequireAccessProps extends AccessRequirements {
  children: (state: AccessState) => ReactNode;
}
export const checkAccess = (user: null | User, {
  match = 'any',
  permissions = [],
  roles = []
}: AccessRequirements): AccessState => {
  const result = checkPureAccess(user, {
    match,
    permissions,
    roles
  });
  const isLoading = false;
  return {
    allowed: result.allowed,
    hasPermission: result.hasPermission,
    hasRole: result.hasRole,
    isAuthenticated: result.isAuthenticated,
    isLoading,
    missingPermissions: result.missingPermissions,
    missingRoles: result.missingRoles,
    user
  };
};
export const RequireAccess = t0 => {
  const $ = _c(6);
  let children;
  let requirements;
  if ($[0] !== t0) {
    ({
      children,
      ...requirements
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = requirements;
  } else {
    children = $[1];
    requirements = $[2];
  }
  const state = useAccess(requirements);
  let t1;
  if ($[3] !== children || $[4] !== state) {
    t1 = children(state);
    $[3] = children;
    $[4] = state;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export const useAccess = requirements => {
  const $ = _c(6);
  const {
    isLoading,
    user
  } = useAuth();
  let t0;
  if ($[0] !== requirements || $[1] !== user) {
    t0 = checkAccess(user, requirements);
    $[0] = requirements;
    $[1] = user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const state = t0;
  let t1;
  if ($[3] !== isLoading || $[4] !== state) {
    t1 = {
      ...state,
      isLoading
    };
    $[3] = isLoading;
    $[4] = state;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};